import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import DateTime from "react-datetime";
import { Popover } from "react-tiny-popover";
import AccountEditOutlineIcon from "mdi-react/AccountEditOutlineIcon";
import InvoiceOutlineIcon from "mdi-react/InvoiceOutlineIcon";
import TruckDeliveryOutlineIcon from "mdi-react/TruckDeliveryOutlineIcon";

export default function BulkCartActionsToolbar({
  tableData,
  setTableData,
  vendors = [],
}) {
  const [showVendorPopover, setShowVendorPopover] = useState(false);
  const [showInvoicePopover, setShowInvoicePopover] = useState(false);
  const [showDeliveryPopover, setShowDeliveryPopover] = useState(false);
  const [bulkInvoiceNo, setBulkInvoiceNo] = useState("");
  const [bulkDelivery, setBulkDelivery] = useState({
    DriverName: "",
    DriverPhoneNumber: "",
    TruckNumber: "",
    DeliveryDate: null,
  });

  const openBulkPopover = setter => {
    setShowVendorPopover(false);
    setShowInvoicePopover(false);
    setShowDeliveryPopover(false);
    setter(v => !v);
  };

  const applyVendorToAllItems = vendorOption => {
    setTableData(
      tableData.map(el => ({
        ...el,
        Vendor: vendorOption.value,
        vendorName: vendorOption.label,
      }))
    );
    setShowVendorPopover(false);
  };

  const applyInvoiceToAllItems = () => {
    if (!bulkInvoiceNo) return;
    setTableData(tableData.map(el => ({ ...el, InvoiceNo: bulkInvoiceNo })));
    setShowInvoicePopover(false);
  };

  const applyDeliveryToAllItems = () => {
    setTableData(
      tableData.map(el => ({
        ...el,
        DriverName: bulkDelivery.DriverName,
        DriverPhoneNumber: bulkDelivery.DriverPhoneNumber,
        TruckNumber: bulkDelivery.TruckNumber,
        DeliveryDate: bulkDelivery.DeliveryDate,
      }))
    );
    setShowDeliveryPopover(false);
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <Popover
        isOpen={showVendorPopover}
        onClickOutside={() => setShowVendorPopover(false)}
        content={
          <div
            className="p-2 bg-white border rounded shadow-sm"
            style={{ minWidth: 220 }}
          >
            <Select
              classNamePrefix="form-select"
              options={vendors}
              isSearchable
              autoFocus
              placeholder="Vendor for all items"
              onChange={applyVendorToAllItems}
            />
          </div>
        }
      >
        <Button
          variant="outline-secondary"
          size="sm"
          className="p-1"
          title="Set vendor for all items"
          onClick={() => openBulkPopover(setShowVendorPopover)}
        >
          <AccountEditOutlineIcon size={16} />
        </Button>
      </Popover>

      <Popover
        isOpen={showInvoicePopover}
        onClickOutside={() => setShowInvoicePopover(false)}
        content={
          <div
            className="p-2 bg-white border rounded shadow-sm"
            style={{ minWidth: 220 }}
          >
            <Form.Control
              size="sm"
              className="mb-2"
              placeholder="Invoice No. for all items"
              autoFocus
              value={bulkInvoiceNo}
              onChange={e => setBulkInvoiceNo(e.target.value)}
              onKeyDown={e => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  applyInvoiceToAllItems();
                }
              }}
            />
            <Button size="sm" onClick={applyInvoiceToAllItems}>
              Apply
            </Button>
          </div>
        }
      >
        <Button
          variant="outline-secondary"
          size="sm"
          className="p-1"
          title="Set invoice number for all items"
          onClick={() => openBulkPopover(setShowInvoicePopover)}
        >
          <InvoiceOutlineIcon size={16} />
        </Button>
      </Popover>

      <Popover
        isOpen={showDeliveryPopover}
        onClickOutside={() => setShowDeliveryPopover(false)}
        content={
          <div
            className="p-2 bg-white border rounded shadow-sm"
            style={{ minWidth: 240 }}
          >
            <Form.Control
              size="sm"
              className="mb-2"
              placeholder="Driver's Name"
              autoFocus
              value={bulkDelivery.DriverName}
              onChange={e =>
                setBulkDelivery({
                  ...bulkDelivery,
                  DriverName: e.target.value,
                })
              }
            />
            <Form.Control
              size="sm"
              className="mb-2"
              placeholder="Driver Phone Number"
              value={bulkDelivery.DriverPhoneNumber}
              onChange={e =>
                setBulkDelivery({
                  ...bulkDelivery,
                  DriverPhoneNumber: e.target.value,
                })
              }
            />
            <Form.Control
              size="sm"
              className="mb-2"
              placeholder="Truck Number"
              value={bulkDelivery.TruckNumber}
              onChange={e =>
                setBulkDelivery({
                  ...bulkDelivery,
                  TruckNumber: e.target.value,
                })
              }
            />
            <DateTime
              timeFormat={false}
              closeOnSelect={true}
              closeOnClickOutside={true}
              dateFormat="MMM DD, YYYY"
              inputProps={{
                className: "date-input form-control form-control-sm mb-2",
                placeholder: "Date Delivered",
                readOnly: true,
              }}
              value={bulkDelivery.DeliveryDate}
              onChange={date =>
                setBulkDelivery({
                  ...bulkDelivery,
                  DeliveryDate: date,
                })
              }
            />
            <Button size="sm" onClick={applyDeliveryToAllItems}>
              Apply
            </Button>
          </div>
        }
      >
        <Button
          variant="outline-secondary"
          size="sm"
          className="p-1"
          title="Set delivery info for all items"
          onClick={() => openBulkPopover(setShowDeliveryPopover)}
        >
          <TruckDeliveryOutlineIcon size={16} />
        </Button>
      </Popover>
    </div>
  );
}
